import { Proposal } from "creso-core/types";
import {
  calculateSipJourney,
  formatAsCrore,
  getProposalStepUp,
} from "creso-core/utils";
import { addMonths, format } from "date-fns";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "web-design-system";
import Amount from "@funds/components/atoms/amount";

export function SipJourneySection({ proposal }: { proposal: Proposal }) {
  const startDate = new Date(proposal.created_at);
  const journey = calculateSipJourney(
    Number(proposal.total_sip_amount || 0),
    Number(proposal.expected_return || 12),
    Number(proposal.duration_months ?? 0),
    getProposalStepUp(
      proposal,
      proposal.proposal_funds.filter((f) => f.type === "SIP").length
    )
  );

  if (!journey.length) return null;

  return (
    <div className="flex flex-col break-before-page">
      <span className="mb-5 text-lg font-semibold">SIP Investment Journey</span>
      <Table className="border border-border rounded-lg">
        <TableHeader className="bg-muted rounded-t-lg">
          <TableRow>
            <TableHead>Time period</TableHead>
            <TableHead>Monthly SIP</TableHead>
            <TableHead>Cumulative</TableHead>
            <TableHead>Expected value</TableHead>
            <TableHead>Returns</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {journey.map((period) => (
            <TableRow key={period.startMonth} className="break-inside-avoid">
              <TableCell className="py-4">
                {format(addMonths(startDate, period.startMonth), "MMM yyyy")}
                &nbsp;-&nbsp;
                {format(addMonths(startDate, period.endMonth), "MMM yyyy")}
              </TableCell>
              <TableCell className="py-4 font-medium">
                <Amount precision={0}>{period.monthlySIP}</Amount>
              </TableCell>
              <TableCell className="py-4">
                {formatAsCrore(period.cumulativeInvested, 2)}
              </TableCell>
              <TableCell className="py-4">
                {formatAsCrore(period.expectedValue, 2)}
              </TableCell>
              <TableCell className="py-4">
                {formatAsCrore(
                  Math.max(period.expectedValue - period.cumulativeInvested, 0),
                  2
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
